/** Default WebAuthn create options — same as IDEE IdP enrollment. */

export const DEFAULT_CEREMONY = {
  platform: true,
  crossPlatform: false,
  userVerification: true,
  residentKey: true,
  algEs256: true,
  algRs256: true,
  algEddsa: false,
  credProps: true,
  prf: false,
  attestation: false,
};

export function toRegisterOptions(c) {
  let authenticator_attachment = 'any';
  if (c.platform && !c.crossPlatform) authenticator_attachment = 'platform';
  if (!c.platform && c.crossPlatform) authenticator_attachment = 'cross-platform';

  const algorithms = [];
  if (c.algEs256) algorithms.push('ES256');
  if (c.algRs256) algorithms.push('RS256');
  if (c.algEddsa) algorithms.push('EdDSA');
  if (algorithms.length === 0) algorithms.push('ES256', 'RS256');

  return {
    user_verification: c.userVerification ? 'required' : 'preferred',
    resident_key: c.residentKey ? 'required' : 'preferred',
    authenticator_attachment,
    attestation: c.attestation ? 'direct' : 'none',
    algorithms,
    prf: c.prf,
    cred_props: c.credProps,
  };
}
